import React from 'react';
import { useBackDismiss } from 'hooks/useBackDismiss';
import styles from './Alert.module.css';

/** 클래스 이름을 해시된 이름으로 바꿉니다. 모르는 이름은 그대로 둡니다.
 *  이름을 바꾸지 않고 스코프만 씌우려고 둔 얇은 헬퍼입니다. */
const cls = (names?: string): string =>
    (names || '').split(' ').filter(Boolean)
        .map((n) => (styles as Record<string, string>)[n] || n).join(' ');

interface AlertProps {
    isOpen: boolean;
    title?: string;
    message: string;
    confirmText?: string;
    onConfirm: () => void;
}

export const Alert: React.FC<AlertProps> = ({
    isOpen,
    title = '알림',
    message,
    confirmText = '확인',
    onConfirm
}) => {
    useBackDismiss(isOpen, onConfirm);
    if (!isOpen) return null;

    return (
        <div className={cls("alert-overlay")} onClick={onConfirm}>
            <div className={cls("alert-container")} onClick={(e) => e.stopPropagation()}>
                <div className={cls("alert-content")}>
                    <h3 className={cls("alert-title")}>{title}</h3>
                    <p className={cls("alert-message")}>{message}</p>
                </div>
                <div className={cls("alert-footer")}>
                    <button className={cls("alert-button confirm")} onClick={onConfirm}>
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};
